import(/* webpackMode: "eager" */ "/vercel/path0/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/common/AdblockDetectOverlay.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/common/CookieBanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/common/GoogleAnalytics.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/common/GoogleTranslate.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/vercel/path0/lib/AuthContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DarkModeProvider"] */ "/vercel/path0/lib/DarkModeContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LanguageProvider"] */ "/vercel/path0/lib/LanguageContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SiteLanguageProvider"] */ "/vercel/path0/lib/SiteLanguageContext.tsx");
